
import { Box,ListItemAvatar, Avatar, Typography, TextField, Button, List, ListItem, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

const ChatList = ({profiles,handleProfileClick}) => {
    // const {profiles} = this.props;
    ChatList.propTypes = {
      handleProfileClick: PropTypes.func.isRequired,
      profiles: PropTypes.arrayOf(PropTypes.string)
    };
     return (
        <List >
        {
          profiles.map((profile,index) => {
           return (  
            <ListItem
              key={index}
              button
              onClick={() => handleProfileClick(profile)} // Call the click handler
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
              <Box sx={{ display: "flex", alignItems: "center" ,p:1}}>
                <ListItemAvatar>
                  <Avatar src={profile.image} alt={profile.ip_address} />
                </ListItemAvatar>
                <ListItemText
                  primary={
               
                    <Typography variant="subtitle1" fontWeight="bold">
                         {profile.ip_address}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography variant="body2" color="textSecondary">
                       {profile.users?.map(user => user.username).join(", ") || "No users"}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        <b>Last Message:</b>{profile.lastmessage?.message ? profile.lastmessage.message.length > 20 
                              ? profile.lastmessage.message.slice(0, 20) + "..." 
                              : profile.lastmessage.message
                            : "No messages yet"}
                      </Typography>
                    </>
                  }
                  
                  sx={{ marginLeft: 2 }}
                />
              </Box>
            </ListItem>
           )
          }
         )
        }
      </List>
    )

}


export default ChatList;
